module.exports = __webpack_public_path__ + "static/media/wall.90b5fae8.jpeg";